import { GridFields } from 'components';
import { isGlobalProject } from 'config';
import { useTranslation } from 'libs/i18n';
import { Input, Stack, Typography } from 'libs/ui';

import {
  dateOfBirthMaxDate,
  dateOfBirthMinDate,
  Field,
} from '../../../forms/createClientForm';

export const Owner = () => {
  const { t } = useTranslation();
  const isGlobal = isGlobalProject();

  return (
    <Stack spacing={12}>
      <Typography variant="subtitle">
        {t('client.createClient.owner')}
      </Typography>
      <GridFields>
        <Field.Text
          fullWidth
          showRequiredMark
          autoComplete="off"
          label={t('client.createClient.fields.brightCode.label')}
          name="owner.brightCode"
          placeholder={t('client.createClient.fields.brightCode.placeholder')}
        />
        {isGlobal && (
          <Input
            disabled
            fullWidth
            label={t('client.createClient.fields.USTax.label')}
            value={t('common.no')}
          />
        )}

        <Field.Text
          fullWidth
          showRequiredMark
          autoComplete="off"
          label={t('client.createClient.fields.email.label')}
          name="owner.email"
          placeholder={t('client.createClient.fields.email.placeholder')}
        />

        <Field.Text
          fullWidth
          showRequiredMark
          label={t('client.createClient.fields.firstName.label')}
          name="owner.firstName"
          placeholder={t('client.createClient.fields.firstName.placeholder')}
        />
        <Field.Text
          fullWidth
          showRequiredMark
          label={t('client.createClient.fields.lastName.label')}
          name="owner.lastName"
          placeholder={t('client.createClient.fields.lastName.placeholder')}
        />
        <Field.Text
          fullWidth
          label={t('client.createClient.fields.middleName.label')}
          name="owner.middleName"
          placeholder={t('client.createClient.fields.middleName.placeholder')}
        />
        <Field.DatePicker
          fullWidth
          showRequiredMark
          label={t('client.createClient.fields.dateOfBirth.label')}
          maxDate={dateOfBirthMaxDate}
          minDate={dateOfBirthMinDate}
          name="owner.dateOfBirth"
          placeholder={t('client.createClient.fields.dateOfBirth.placeholder')}
        />

        <Field.Phone
          fullWidth
          showRequiredMark
          label={t('client.createClient.fields.phoneNumber.label')}
          maxLength={22}
          name="owner.phoneNumber"
          placeholder={t('client.createClient.fields.phoneNumber.placeholder')}
          type="phone"
        />
        <Field.Text
          fullWidth
          showRequiredMark
          label={t('client.createClient.fields.personalAccountNumber.label')}
          name="owner.personalAccountNumber"
          placeholder={t(
            'client.createClient.fields.personalAccountNumber.placeholder'
          )}
        />
        <Field.DatePicker
          fullWidth
          showRequiredMark
          label={t(
            'client.createClient.fields.personalAccountOpeningDate.label'
          )}
          name="owner.personalAccountOpeningDate"
          placeholder={t(
            'client.createClient.fields.personalAccountOpeningDate.placeholder'
          )}
        />
      </GridFields>
    </Stack>
  );
};
